import { http } from '../../../api'
const apiUrl = '/qa'
const faq = {
  namespaced: true,
  state: {
    dataList: [],
    currencyList: [],
    users: [],
    itemData: null
  },
  actions: {
    getAllData: ({ commit }, params) => {
      let url = apiUrl
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setList', res.data.data)
        return res.data
      })
    },
    create: ({ commit }, params) => {
      return http.post(apiUrl, params).then(res => {
        return res.data
      })
    },
    delete: ({ commit }, params) => {
      return http.delete(apiUrl + '/' + params.id).then(res => {
        commit('setRemoveList', params.id)
      })
    },
    getCreateData: ({ commit }, text) => {
      return http.get(apiUrl + '/create?search=' + text).then(res => {
        commit('setCreateData', res.data.data)
        return res.data.data
      })
    },
    getData: ({ commit }, params) => {
      return http.get(apiUrl + '/' + params.id).then(res => {
        commit('setData', res.data.data)
      })
    },
    update: ({ commit }, params) => {
      return http.put(apiUrl + '/' + params.id, params.data).then(res => {
      })
    }
  },
  mutations: {
    setList (state, data) {
      state.dataList = data
    },
    setCreateData (state, data) {
      state.currencyList = data.currencies
      state.users = data.users
    },
    setRemoveList (state, id) {
      state.dataList = state.dataList.filter(item => item.id !== id)
    },
    setData (state, data) {
      state.itemData = data
    }
  },
  getters: {
    dataList: state => state.dataList,
    itemData: state => state.itemData
  }
}

export default faq
